var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOperatingSystem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5596e6",
    id: "operating-system_00000080195605699540145290000015536501555804185762_",
    d: "M23,29.36H9v-0.72h6.64v-4.28H3 c-1.301,0-2.36-1.059-2.36-2.36V5c0-1.301,1.059-2.36,2.36-2.36h26c1.302,0,2.36,1.059,2.36,2.36v17c0,1.302-1.059,2.36-2.36,2.36 H16.36v4.279H23V29.36z M1.36,19.36V22c0,0.904,0.736,1.64,1.64,1.64h26c0.904,0,1.64-0.735,1.64-1.64v-2.64H1.36z M1.36,18.64 h29.28V5c0-0.904-0.735-1.64-1.64-1.64H3C2.096,3.36,1.36,4.096,1.36,5V18.64z M28,17.36c-0.75,0-1.36-0.61-1.36-1.36 c0-0.058,0.004-0.116,0.011-0.172L5.072,6.836C4.823,7.155,4.435,7.36,4,7.36C3.25,7.36,2.64,6.75,2.64,6S3.25,4.64,4,4.64 S5.36,5.25,5.36,6c0,0.058-0.003,0.116-0.011,0.172l21.58,8.992c0.249-0.318,0.637-0.523,1.071-0.523c0.75,0,1.36,0.61,1.36,1.36 S28.75,17.36,28,17.36z M28,15.36c-0.353,0-0.64,0.287-0.64,0.64s0.287,0.64,0.64,0.64s0.64-0.287,0.64-0.64S28.353,15.36,28,15.36z  M4,5.36C3.647,5.36,3.36,5.647,3.36,6S3.647,6.64,4,6.64S4.64,6.353,4.64,6S4.353,5.36,4,5.36z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperatingSystem);
export default __webpack_public_path__ + "../static/product-explorer-main-offerings/assets/operating-system.417c9fe4edeee285f79fb28140062ebc.svg";
export { ForwardRef as ReactComponent };